import script from "./AppRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppRow.vue?vue&type=script&lang=ts&setup=true"

import "./AppRow.vue?vue&type=style&index=0&id=4516f742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4516f742"]])

export default __exports__